// Place all the behaviors and hooks related to the matching controller here.
// All this logic will automatically be available in application.js.
import { select2RemoteAjax } from './select2_remote';

(function() {

$(document).on("turbo:load", function() {

  if ($("#schedule_sche_type").is(':visible')) {
    $("#schedule_sche_type").select2({placeholder: "種別"});
  }
  if ($("#schedule_user_id").is(':visible')) {
    $("#schedule_user_id").select2({placeholder: "担当弁護士"});
  }

  $('#schedule_contact_id').select2(ajax_select);

  // 事件選択時に関連弁護士プルダウンを更新
  // まずは自分と秘書のみをAssigneeにできるようにする、事件選択時に更新は後ほど
  if ($('#schedule_assignee_id').is(':visible')) {
    $('#schedule_assignee_id').select2({allowClear: true});
  }
  if ($('#schedule_matter_id').is(':visible')) {
    $('#schedule_matter_id').select2({allowClear: true});
  }
//  if $("#schedule_matter_id").is(':visible')
//    $('#schedule_assignee_id').select2({allowClear: true})
//    new Select2Cascade($('#schedule_matter_id'), $('#schedule_assignee_id'), '/matters/:parentId:/matter_users', {placeholder: "依頼人：事件名"})

  $('#hw-search-option').on('click', function(ev) {
    ev.preventDefault();
    $('#hw-option-group').toggle();
  });
});

const ajax_select = {
  language: "ja",
  allowClear: true,
  ajax: select2RemoteAjax({
    url: "/contacts.json",
    query: params => ({ search_text_cont_all: params.term })
  }),
  escapeMarkup(markup) { return markup; }, // let our custom formatter work
  minimumInputLength: 1
};

})();
